import { SessionStorage } from '../../core/services/global/storage/session-storage.service';
import { Injectable } from '@angular/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';

@Injectable()
export class StepValidationStorageService {

  private realTimeStepsValidity: StepValidity[] = [];
  private readonly STORAGE_KEY = 'stepsValidity';

  constructor(private _sessionStorage: SessionStorage) {
  }

  isStepValidRealTime(stepKey: string): boolean {
    const stepValidity = this.realTimeStepsValidity.find(step => step.stepKey === stepKey);
    return stepValidity ? stepValidity.isValidate : true;
  }

  updateRealTimeStepValidity(stepKey: string, isValidate: boolean, substepIndex?: number): void {
    const stepValidity: StepValidity = {
      stepKey: stepKey,
      isValidate: isValidate
    };
    if (isNotNullOrUndefined(substepIndex)) {
      stepValidity.substepIndex = substepIndex;
    }
    this.updateStepValidity(this.realTimeStepsValidity, stepValidity);
  }

  updateStepValidationStorage(stepKey: string, isValidate: boolean, substepIndex?: number) {
    let steps = this._sessionStorage.get(this.STORAGE_KEY);
    const stepValidity: StepValidity = {
      stepKey: stepKey,
      isValidate: isValidate
    };
    if (isNotNullOrUndefined(substepIndex)) {
      stepValidity.substepIndex = substepIndex;
    }
    if (steps && steps.length > 0) {
      steps = this.updateStepValidity(steps, stepValidity);
    } else {
      steps = [];
      steps.push(stepValidity);
    }
    this._sessionStorage.put(this.STORAGE_KEY, steps);
  }

  isValidStep(stepKey: string, substepIndex?: number): boolean {
    const stepValidity = this.getStepValidity(stepKey, substepIndex);
    if (isNotNullOrUndefined(stepValidity)) {
      return stepValidity.isValidate;
    }
    return this._sessionStorage.get(stepKey);
  }

  clearSteps(): void {
    this._sessionStorage.remove(this.STORAGE_KEY);
  }

  private getStepValidity(stepKey: string, substepIndex?: number): StepValidity {
    const stepsValidity: StepValidity[] = this._sessionStorage.get(this.STORAGE_KEY);

    if (!isNotNullOrUndefined(stepsValidity)) {
      return null;
    }

    if (isNotNullOrUndefined(substepIndex)) {
      return stepsValidity.find(stepVal => stepVal.stepKey === stepKey && stepVal.substepIndex === substepIndex);
    } else {
      return stepsValidity.find(stepVal => stepVal.stepKey === stepKey);
    }
  }

  private updateStepValidity(steps: StepValidity[], stepValidity: StepValidity): any[] {
    const matched = stepValidity.hasOwnProperty('substepIndex') ?
      steps.find(step => step.stepKey === stepValidity.stepKey && step.substepIndex === stepValidity.substepIndex) :
      steps.find(step => step.stepKey === stepValidity.stepKey);

    if (isNotNullOrUndefined(matched)) {
      const index = steps.indexOf(matched);
      steps[index] = stepValidity;
    } else {
      steps.push(stepValidity);
    }
    return steps;
  }
}

export interface StepValidity {
  stepKey: string;
  substepIndex?: number;
  isValidate: boolean;
}
